import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { REBUILD_COPY } from '../components/rebuild/rebuildCopy';
import { RebuildHero, RebuildWhy, RebuildSituations, RebuildBlog, RebuildTools } from '../components/rebuild/RebuildSections';

export default function RebuildCredit() {
  const { language } = useLanguage();
  const en = language === 'en';
  const c = REBUILD_COPY[en ? 'en' : 'fr'];

  useEffect(() => {
    document.title = c.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', c.meta);
  }, [c]);

  return (
    <div className="min-h-screen pt-24 md:pt-[120px] bg-white" data-testid="rebuild-credit-page">
      <RebuildHero c={c} />
      <RebuildWhy c={c} />
      <RebuildSituations c={c} />
      <RebuildBlog c={c} en={en} />
      <RebuildTools c={c} />
    </div>
  );
}
